<template>
  <div v-bind:id="id" class="modal" v-bind:class="{active: showModal}" v-show="showModal">
    <div class="modal-header">
      <h3><span>本日のピックアップ！ リーダーたちへ ～実際に投げかけられた言葉～（ヒント集より）</span>{{ categoryLabel }}</h3>
      <a href="javascript:void(0)" class="btn-close modal-close" v-on:click="closeModal" aria-label="閉じる"></a>
    </div>
    <div class="modal-body" v-bind:style="{'max-height': maxHeight + 'px'}">
      <div class="tips-body" style="white-space: pre-line">{{ body }}</div>
    </div>
  </div>
</template>

<script>
  import ModalView from '../components/modal-view'

  export default {
    name: 'DailyHint',
    extends: ModalView,
    props: ['api'],
    data () {
      return {
        categoryLabel: '',
        body: ''
      }
    },
    created () {
      if (Cookies.get('daily_hint') !== '1') {
        this.fetchHint()
      }
    },

    methods: {
      fetchHint () {
        $.ajax({
          url: this.api,
          type: 'GET',
          success: (json) => {
            if (json.hint) {
              this.categoryLabel = json.hint.category_label
              this.body = json.hint.body

              this.ready = true
              this.$parent.openNextModal()
            }
          }
        })
      }
    }
  }
</script>
